export default "__VITE_ASSET__BwmlPbcD__"